var exports = {
  "x": "xf61da738--59ac3b--offer",
  "nV": "xf61da738--59ac3b--gallery",
  "gV": "xf61da738--59ac3b--gallery-link",
  "pq": "xf61da738--59ac3b--info",
  "Sl": "xf61da738--59ac3b--image",
  "BI": "xf61da738--59ac3b--favorite",
  "Ix": "xf61da738--59ac3b--facts",
  "q9": "xf61da738--59ac3b--price",
  "h_": "xf61da738--59ac3b--description",
  "hl": "xf61da738--59ac3b--address",
  "C5": "xf61da738--59ac3b--location",
};

module.exports = exports;
